import { useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-background-50/90 backdrop-blur-md border-b border-background-200/70">
      <div className="w-full px-4 md:px-10 h-16 md:h-20 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-3 shrink-0 cursor-pointer">
          <span className="w-10 h-10 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 flex items-center justify-center text-2xl">
            <i className="ri-apple-fill" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading font-black text-lg md:text-xl text-foreground-950 tracking-wide whitespace-nowrap">
              青苹果影院
            </span>
            <span className="font-label text-[10px] tracking-[0.3em] text-foreground-400">
              RESOURCE ENTRY
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={link.href}
              className="px-4 py-2 rounded-md font-label text-sm text-foreground-700 hover:text-primary-700 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#address"
            className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-label text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-link-m" aria-hidden="true"></i>
            获取最新入口
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50">
          <nav className="px-4 py-3 flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 rounded-md font-label text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#address"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-label text-sm font-medium cursor-pointer"
            >
              <i className="ri-link-m" aria-hidden="true"></i>
              获取最新入口
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}